import BgcForm from './comonents/BgcForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <BgcForm />
    </div>
  );
}

export default App;
